module.exports = __webpack_public_path__ + "img/004-adobe.0711c256.svg";